export const BrandingData = {

    version: "1.0.0.1101",
    bussinessDomain: "Garage",

    siteName: "Auto Connect CRM",
    poweredBy: "iClicks",
    titleSuffix: " | Auto Connect CRM",
    domain: "crm.autoconnect.lk",
    images: {
        logoLightPath: "assets/images/iclicks-high-resolution-logo-white-transparent.png",
        logoDarkPath: "assets/images/iclicks-high-resolution-logo-transparent.png",
    },

    messageDisplayTimeout: 3000,



};